export default __webpack_public_path__ + "static/media/Diagrams.3303b1d4.png";